import type { IAssetsFilter } from "@/models/filter.model";
import { identityManagerApi } from "@/services/infra/client-apis/identity-manager-api/identity-manager-api";
import { httpService } from "@/services/infra/https.service/http.service";
import type {
  Application,
  ApplicationCreationRequest,
  ApplicationPostResponse,
  RegenerateApplicationSecret200Response,
} from "@/swagger-models/identity-manager-client";

export const applicationsService = {
  list,
  remove,
  create,
  regenerateSecret,
  getRunAiInstallerAppClient,
};

async function list(filterBy: IAssetsFilter): Promise<Application[]> {
  try {
    const response = await identityManagerApi.applicationsApi.getApplications({
      params: {
        projectId: filterBy.projectId,
        scope: filterBy.scope,
        usageInfo: filterBy.usageInfo,
      },
    });
    return response.data;
  } catch (err: unknown) {
    throw httpService.handleHttpError(err);
  }
}

async function remove(id: string): Promise<void> {
  try {
    const response = await identityManagerApi.applicationsApi.deleteApplicationById(id);
    return response.data;
  } catch (err: unknown) {
    throw httpService.handleHttpError(err);
  }
}

async function create(appCreationRequest: ApplicationCreationRequest): Promise<ApplicationPostResponse> {
  try {
    const response = await identityManagerApi.applicationsApi.createApplication(appCreationRequest);
    return response.data;
  } catch (err: unknown) {
    throw httpService.handleHttpError(err);
  }
}

async function regenerateSecret(id: string): Promise<RegenerateApplicationSecret200Response> {
  try {
    const response = await identityManagerApi.applicationsApi.regenerateApplicationSecret(id);
    return response.data;
  } catch (err: unknown) {
    throw httpService.handleHttpError(err);
  }
}

async function getRunAiInstallerAppClient(): Promise<ApplicationPostResponse> {
  try {
    const response = await identityManagerApi.applicationsApi.getInstallerApp();
    return response.data;
  } catch (err: unknown) {
    throw httpService.handleHttpError(err);
  }
}
